// The single implementation (2026-07-27 duplicate-export dedup). There used to
// be two exports under this name: this file, and a copy in
// workspace/functions/ that won at runtime because the workspace barrel is
// spread eagerly over the shared library.
//
// The workspace copy's behaviour is what survived — the version that lived
// here took an `options = {}` param and read it as `options.visible ||
// 'default'`, which can never express "hide" (false is falsy, so it always
// fell through to the shown state), and it called a never-registered
// `el.call('exec', ...)` helper. Every real call site (NavbarTooltipParent,
// AppNavbar, EnvsNavbar, CanvasPagesDropdown) already passes the
// `{ visible: true|false }` / no-args shape this implementation expects.
//
// It lives in SHARED rather than workspace because shared is the layer every
// app scope merges. preview's PreviewNavbar extends NavbarTooltipParent in
// four places, and preview/marketplace/gazer/demo/design-system merge shared
// WITHOUT workspace — keeping the only copy in workspace would have left
// `el.call('setNavbarTooltipPosition')` unresolved in all of them.
export const setNavbarTooltipPosition = function setNavbarTooltipPosition(params) {
  const el = this
  const tooltip = el.lookup('NavbarTooltip')
  if (!tooltip || !tooltip.node) return

  const node = tooltip.node

  if (!params || !params.visible) {
    node.style.opacity = '0'
    node.style.visibility = 'hidden'
    node.style.transform = 'translate3d(-50%,-10%,0)'
    return
  }

  const titleVal = typeof el.title === 'function' ? el.title(el, el.state) : el.title
  const title = titleVal || ''

  if (tooltip.P && tooltip.P.node) {
    tooltip.P.node.textContent = title
  }

  const btnRect = el.node.getBoundingClientRect()
  const parentRect = tooltip.parent.node.getBoundingClientRect()
  const left = btnRect.left - parentRect.left + btnRect.width / 2

  node.style.left = left + 'px'
  node.style.opacity = '1'
  node.style.visibility = 'visible'
  node.style.transform = 'translate3d(-50%,0,0)'
}
